import React from "react";
import "../styles/SideBar.css";
import {
  FaHeartbeat,
  // FaClipboardList,
  // FaExclamationTriangle,
  // FaShieldAlt,
  // FaCheckSquare,
  // FaTachometerAlt,
  // FaChartLine,
  // FaPalette,
  // FaComments,
  // FaCalendarAlt,
  FaUser,
  // FaBook,
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const Sidebar = ({ isOpen }) => {
  const navigate = useNavigate();
  const role = localStorage.getItem("userRole");
  const user = JSON.parse(localStorage.getItem("user"));
  const isAdmin = role === "1" || user?.role === "admin";

  if (!isAdmin) return null;

  return (
    <div className={`sidebar ${isOpen ? "open" : "collapsed"}`}>
      <div className="sidebar-header">🧑‍💼 Admin Panel</div>

      <button className="sidebar-btn" onClick={() => navigate("/admin")}>
        <FaHeartbeat className="me-2" />
        Gateway
      </button>
      {/* <button className="sidebar-btn" onClick={() => navigate("/tasks")}>
        <FaClipboardList className="me-2" />
        My Task
      </button>
      <button className="sidebar-btn" onClick={() => navigate("/compliance")}>
        <FaExclamationTriangle className="me-2" />
        Compliance
      </button>
      <button className="sidebar-btn" onClick={() => navigate("/screening")}>
        <FaShieldAlt className="me-2" />
        Background Screening
      </button>
      <button className="sidebar-btn" onClick={() => navigate("/review")}>
        <FaCheckSquare className="me-2" />
        Ready for Review
      </button>
      <button
        className="sidebar-btn"
        onClick={() => navigate("/lms-dashboard")}
      >
        <FaTachometerAlt className="me-2" />
        LMS Dashboard
      </button>
      <button className="sidebar-btn" onClick={() => navigate("/insights")}>
        <FaChartLine className="me-2" />
        Insight Dashboard
      </button>
      <button
        className="sidebar-btn"
        onClick={() => navigate("/communication")}
      >
        <FaPalette className="me-2" />
        Communication
      </button>
      <button className="sidebar-btn" onClick={() => navigate("/chat")}>
        <FaComments className="me-2" />
        Chat
      </button>
      <button className="sidebar-btn" onClick={() => navigate("/calendar")}>
        <FaCalendarAlt className="me-2" />
        Calendar
      </button>

      <button className="sidebar-btn" onClick={() => navigate("/legend")}>
        <FaBook className="me-2" />
        Legend
      </button> */}
      <button
        className="sidebar-btn"
        onClick={() => navigate(`/edit-user/${localStorage.getItem("userId")}`)}
      >
        <FaUser className="me-2" />
        Account Setting
      </button>
    </div>
  );
};

export default Sidebar;
